import React from 'react';
import { ChevronLeftIcon, CreditCardIcon } from 'lucide-react';
export const IdentityDocumentsPrep = ({
  onBack,
  onNext
}) => {
  return <div className="flex flex-col p-6 flex-grow" data-id="element-171">
      <div className="flex items-center mb-6" data-id="element-172">
        <button onClick={onBack} className="mr-4" data-id="element-173">
          <ChevronLeftIcon size={24} data-id="element-174" />
        </button>
        <div className="flex-grow flex space-x-2" data-id="element-175">
          <div className="h-1 bg-[#5c5cf5] flex-grow rounded-full" data-id="element-176"></div>
          <div className="h-1 bg-[#5c5cf5] flex-grow rounded-full" data-id="element-177"></div>
          <div className="h-1 bg-[#5c5cf5] flex-grow rounded-full" data-id="element-178"></div>
          <div className="h-1 bg-gray-200 flex-grow rounded-full" data-id="element-179"></div>
        </div>
      </div>
      <div className="flex justify-center mb-6" data-id="element-180">
        <div className="bg-[#eeeeff] p-4 rounded-full" data-id="element-181">
          <CreditCardIcon size={32} className="text-[#5c5cf5]" data-id="element-182" />
        </div>
      </div>
      <h1 className="text-2xl font-bold mb-4 text-center" data-id="element-183">
        Ready for identity verification
      </h1>
      <p className="text-gray-700 mb-6 text-center" data-id="element-184">
        Next you'll need your driver's license or U.S. passport so we can
        validate your identity quickly and easily.
      </p>
      <div className="bg-gray-100 rounded-lg p-4 mb-6" data-id="element-185">
        <h3 className="font-semibold mb-2" data-id="element-186">Please have ready:</h3>
        <ul className="list-disc pl-5 text-gray-700" data-id="element-187">
          <li className="mb-1" data-id="element-188">U.S. driver's license, OR</li>
          <li className="mb-1" data-id="element-189">U.S. passport</li>
        </ul>
        <p className="text-gray-700 text-sm mt-2" data-id="element-190">
          Your ID must be valid and not expired. Make sure it's easily
          accessible before proceeding.
        </p>
      </div>
      <div className="mt-auto" data-id="element-191">
        <button className="w-full bg-[#5c5cf5] text-white py-3 rounded-full font-medium" onClick={onNext} data-id="element-192">
          Next
        </button>
      </div>
    </div>;
};